import { keepPreviousData, useMutation, useQuery } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import { api } from '.';
import { CommonResType } from '@/types/commonApiType';

type GetPayInfoDataType = {
	pay_info_pk?: string;
	pay_info_amt: number;
	pay_info_pay_method: string;
	pay_info_tran_date: string;
	pay_info_member_type: string;
};

type GetPayInfoResType = {
	member_type: string;
	pay_info: GetPayInfoDataType[];
};
export const useGetPayInfoApi = () => {
	const url = '/v1/front/getPayInfo';
	return useQuery<AxiosResponse, AxiosError, GetPayInfoResType>({
		queryKey: [url],
		queryFn: () => api.get(url),
		select: (res) => res.data.data,
		placeholderData: keepPreviousData,
	});
};

type GetPayReceiptParamsType = {
	pay_info_pk: string;
};

type GetPayReceiptResType = {
	member_type: string;
	pay_info: GetPayInfoDataType[];
};
export const useGetReceiptApi = (params: GetPayReceiptParamsType, enabled: boolean) => {
	const url = '/v1/front/getReceipt';
	return useQuery<AxiosResponse, AxiosError, GetPayReceiptResType>({
		queryKey: [url, params],
		queryFn: () => api.get(url, params),
		select: (res) => res.data.data,
		placeholderData: keepPreviousData,
		enabled: enabled,
	});
};

type CreateTransferInfoDataType = {
	member_type: string;
	amount: string;
	goods_name: string;
	goods_type: string;
};

export const usePostCreateTransferInfoApi = () => {
	const url = '/v1/front/createTransferInfo';
	return useMutation<AxiosResponse<CommonResType>, AxiosError, CreateTransferInfoDataType>({
		mutationFn: (data: CreateTransferInfoDataType) => api.post(url, data),
	});
};

type PaymentInfoDataType = {
	member_type: string;
	amount: number;
	goods_name: string;
	goods_type: string;
};
type PaymentResponse = CommonResType<{
	data: {
		aid: string;
		nextMobileUrl: string;
		nextPcUrl: string;
		nextAppUrl: string;
		createTime: string;
		expireTime: string;
	};
	mbrRefNo: string;
	amount: number;
}>;

export const usePostPaymentReadyApi = () => {
	const url = '/v1/front/pg/ready';
	return useMutation<AxiosResponse<PaymentResponse>, AxiosError, PaymentInfoDataType>({
		mutationFn: (data: PaymentInfoDataType) => api.post(url, data),
		onSuccess: (res) => {
			if (res.data.success) {
				const { nextMobileUrl, nextPcUrl, nextAppUrl } = res.data.data.data;
				const { mbrRefNo } = res.data.data;
				sessionStorage.setItem('mbrRefNo', mbrRefNo);
				const url = window.location.href;
				const isMobile = /Mobi|Android/i.test(navigator.userAgent);
				if (isMobile) {
					window.open(nextMobileUrl, '_self');
				} else if (url.includes('app')) {
					window.open(nextAppUrl, '_self');
				} else {
					window.open(nextPcUrl, '_self');
				}
			}
		},
	});
};

type PaymentApprovalDataType = {
	aid: string;
	authToken: string;
	mbrRefNo?: string;
};
type PaymentApprovalResType = CommonResType;
export const usePostPaymentApprovalCallbackApi = () => {
	const url = '/v1/front/pg/approvalCallback';
	return useMutation<AxiosResponse<PaymentApprovalResType>, AxiosError, PaymentApprovalDataType>({
		mutationFn: (data: PaymentApprovalDataType) => api.post(url, data),
		onError: (error) => {
			console.error('Payment approval error:', error);
		},
	});
};
type GetAnnualFeePaidDataType = {
	goods_name: string;
};

export const usePostAnnualFeePaidApi = () => {
	const url = '/v1/front/getAnnualFeePaid';
	return useMutation<AxiosResponse<PaymentApprovalResType>, AxiosError, GetAnnualFeePaidDataType>({
		mutationFn: (data: GetAnnualFeePaidDataType) => api.post(url, data),
	});
};
